import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import InstitutionSearchInput, {InstitutionSearchInputInstitution} from 'institutions/InstitutionSearchInput';
import {ButtonSize} from 'ui-library/buttons/Button';
import Menu from 'ui-library/menus/Menu';
import pickDefined from 'util/pickDefined';

import {InstitutionFilter} from '../SearchConstants';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps} from './base/FilterFormConstants';
import PrimaryFilterFormSkeleton from './base/PrimaryFilterFormSkeleton';

// Exported for testing.
export interface InstitutionFilterFormProps extends BaseFilterFormProps {
  filter: InstitutionFilter;
  onChangeFilter: (filter: InstitutionFilter) => void;
}

function getFilterText(filter: InstitutionFilter): string {
  return filter.value == null ? 'Institution' : `Institution: ${filter.value.name}`;
}

export default function InstitutionFilterForm(props: InstitutionFilterFormProps): JSX.Element {
  const onChangeValue = (institution: InstitutionSearchInputInstitution): void => {
    props.onChangeFilter({
      ...props.filter,
      value: {id: institution.id, name: institution.fullName},
    });
  };

  const menu = <InstitutionSearchInput onSelect={onChangeValue} menuWidth={Menu.WIDTHS.MEDIUM} />;
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);

  return (
    <div className={css(styles.filter)}>
      <PrimaryFilterFormSkeleton
        {...skeletonProps}
        closeOnInsideClick={true}
        menuOverride={menu}
        dropdownToggleText={getFilterText(props.filter)}
        buttonSize={ButtonSize.SMALL}
        alwaysDropDown={true}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  filter: {
    maxWidth: '150px',
  },
});
